import { useContext } from 'react'
import { GlobalNotificationContext } from 'src/context/GlobalNotificationContext'

export const useGlobalNotification = () => useContext(GlobalNotificationContext)
